import { createReducer } from "@reduxjs/toolkit";
import {
  clearAddressAndCost,
  setAddressAndCost,
  setDeliveryType,
  setPickupLocation,
  setPickupLock,
} from "./actions";

export const DELIVERY_ADDRESS = "address";
export const DELIVERY_PICKUP = "pickup";

export function normalizeDeliveryCost(value) {
  if (
    value === null ||
    value === undefined ||
    (typeof value !== "number" && typeof value !== "string") ||
    (typeof value === "string" && !value.trim())
  )
    return null;
  const cost = Number(value);
  return Number.isFinite(cost) && cost >= 0 ? cost : null;
}

export default createReducer(
  {
    type: "",
    address: "",
    cost: null,
    distance: null,
    placeId: "",
    latitude: null,
    longitude: null,
    quote: "",
    pickup_location_id: null,
    pickup_locked: false,
  },
  {
    [setAddressAndCost]: (state, { payload }) => {
      state.address = payload.address;
      state.cost = normalizeDeliveryCost(payload.cost);
      state.distance = payload.distance;
      state.placeId = payload.place_id;
      state.latitude = payload.latitude;
      state.longitude = payload.longitude;
      state.quote = payload.quote;
    },
    [clearAddressAndCost]: (state) => {
      state.address = "";
      state.cost = null;
      state.distance = null;
      state.placeId = "";
      state.latitude = null;
      state.longitude = null;
      state.quote = "";
    },
    [setDeliveryType]: (state, { payload }) => {
      state.type = payload;
    },
    [setPickupLocation]: (state, { payload }) => {
      state.pickup_location_id = payload;
    },
    [setPickupLock]: (state, { payload }) => {
      state.pickup_locked = payload;
    },
  }
);
